import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import type {
	Action,
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	Store,
} from 'react-sweet-state';

export type AutoFocusTargetOptions = undefined | 'version comment' | 'access' | 'location';

export type PublishModalSource = string;

export type PublishModalMountStateType = {
	shouldDisplayPublishModal: boolean;
	initialFocusTarget: AutoFocusTargetOptions;
	modalSource?: PublishModalSource;
};

type PublishModalMountActionsType = {
	openPublishModal: (
		modalSource?: PublishModalSource,
	) => Action<PublishModalMountStateType, void, void>;
	closePublishModal: () => Action<PublishModalMountStateType, void, void>;
	setInitialFocusTarget: (
		newFocusTarget: AutoFocusTargetOptions,
	) => Action<PublishModalMountStateType, void, void>;
};

export const PublishModalMountStore: Store<
	PublishModalMountStateType,
	PublishModalMountActionsType
> = createStore<PublishModalMountStateType, PublishModalMountActionsType>({
	name: 'PublishModalMountStore',
	initialState: {
		shouldDisplayPublishModal: false,
		initialFocusTarget: undefined,
		modalSource: undefined,
	},
	actions: {
		openPublishModal:
			(modalSource) =>
			({ setState }) =>
				setState({ shouldDisplayPublishModal: true, modalSource }),
		closePublishModal:
			() =>
			({ setState }) =>
				setState({ shouldDisplayPublishModal: false, modalSource: undefined }),
		setInitialFocusTarget:
			(newFocusTarget) =>
			({ setState }) =>
				setState({ initialFocusTarget: newFocusTarget }),
	},
});

export const usePublishModalMountStore: HookStateFunction<PublishModalMountStateType, void> =
	createStateHook(PublishModalMountStore);
export const usePublishModalMountActions: HookActionsFunction<
	BoundActions<PublishModalMountStateType, PublishModalMountActionsType>
> = createActionsHook(PublishModalMountStore);
